// SigV4 presigned S3 URLs carry their signature in the query string.
const PRESIGNED_QUERY = /[?&]x-amz-signature=/i;

/** True for a presigned S3 URL: whoever holds it can read (or upload) that object until it expires. */
export function isPresignedUrl(url: string): boolean {
  return PRESIGNED_QUERY.test(url);
}

/**
 * The URL without its query string when it is presigned, so telemetry keeps the host and object path
 * but never a working link. Anything else comes back unchanged.
 */
export function stripPresignedQuery(url: string): string {
  if (!isPresignedUrl(url)) {
    return url;
  }
  const queryStart = url.indexOf('?');
  return queryStart === -1 ? url : url.slice(0, queryStart);
}
